import { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFormValue } from "../../redux/slices/datasourcespageslice";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { RadioButton } from "@progress/kendo-react-inputs";
import { FormInput, FormDropDownList, FormTextArea, FormDropDownListById, FormComboBoxById, FormHidden} from "../../forms/form-components";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { FormRegion } from "../../components/formregion";
import { FormToggleButton } from "../../components/togglebutton";
import { TableValueList } from "./tablevaluelist";
import { formValidator } from "./datasourcespageformvalidator";
import { AggregateFunction} from "../../lib/aggregatefunctions";
import i18next from "i18next";
import { useTranslation } from "react-i18next";


export const DataSourcesPageForm = props => {
  const dispatch = useDispatch();
  const currentTheme = useSelector(state => state.currentTheme);
  const pageState = useSelector(state => state.dataSourcesPage);
  const currentDataset = pageState.currentDataset;
  const aggregateFunctions = [{id: 0, title: "None"}, ...AggregateFunction.functions.sort((a, b) => (a.title < b.title) ? -1 : (a.title > b.title ? 1 : 0))];
  const aggregateFunctionId = pageState.formValues.AggregateFunctionId;
  const aggregateFunction = aggregateFunctionId <= 0 ? null : AggregateFunction.getById(aggregateFunctionId);
  const updateDirtyState = props.updateDirtyState;
  const appearance = useSelector(state => state.appearance);  
  const { t } = useTranslation();

  const typeIdsList = [
    {id:1, title: t("datasources.value")}, 
    {id:2, title: t("datasources.table")}
];

  let aggregateExpressions = currentDataset ? [{Id: null, Title: t("datasources.none"), Name: "None"}, ...currentDataset.Fields.filter(e => e.IsExpression==true && e.IsAggregate==true)] : [];
  let fields = currentDataset ? currentDataset.Fields.filter(e => e.IsExpression==false || e.IsAggregate==false) : [];

  if(aggregateFunction)
     fields = fields.filter(e => aggregateFunction.appliesToDataType(e.DataTypeId));

  //add the none field
  fields = [{Id: null, Title: t("datasources.none"), Name: "None"}, ...fields];

    //handle is dirty
    useEffect(()=>{
        updateDirtyState();
   }, [pageState.formInitialValues, pageState.formValues]);

  return (
    <Fragment>
        <Form    
            validator={formValidator}
            key={pageState.formKey}
            initialValues={{...pageState.formInitialValues}}
            render={(formRenderProps) => {

                return (
                    <FormElement horizontal={false}
                            style={{
                                // width: 250,
                            }}
                    >                        
                        <FormRegion className="form-region-1">                        
                            <div className="form-group form-group-1">
                                {
                                    pageState.formValues.ViewMode == 1 &&
                                    <div>
                                        <Field 
                                            id={"Title"}
                                            name={"Title"}
                                            label={pageState.mode == 2 && pageState.formValues.IsWidgetAttached ? t("datasources.titlewidget") : t("datasources.title1")}
                                            component={FormInput}
                                            onChange={ e => dispatch(setFormValue({id: "Title", value: e.value}))}
                                            autoFocus={true}
                                            disabled={pageState.isProcessing || pageState.formValues.IsSystem}
                                            style={{width: "100%", flex: 1}}
                                            maxLength={50}
                                        />            
                                        <Field                                    
                                            id={"Description"}
                                            name={"Description"}
                                            label={t("datasources.description1")}
                                            component={FormTextArea}
                                            style={{height:50, width: "100%"}}
                                            onChange={ e => dispatch(setFormValue({id: "Description", value:e.value}))}
                                            disabled={pageState.isProcessing || pageState.formValues.IsSystem}
                                            maxLength={255}
                                        />                                                                                 
                                        <div className="typeIds" style={{display: "flex", marginTop: 30, justifyContent: "space-between",}} >
                                            <Field component={FormToggleButton} values={typeIdsList} id="TypeId" name="TypeId" 
                                                disabled={pageState.isProcessing || pageState.formValues.IsSystem || pageState.mode == 2}
                                                onChange={e => {
                                                    let isAggregate = e.value == 1 ? true : false;

                                                    dispatch(setFormValue({id: "TypeId", value: e.value}));

                                                    dispatch(setFormValue({id:"IsAggregate", value: isAggregate}));
                                                    dispatch(setFormValue({id: "AggregateExpressionId", value: null}));
                                                    dispatch(setFormValue({id: "AggregateFunctionId", value: 0}));
                                                    dispatch(setFormValue({id: "FieldId", value: null}));
                                                    dispatch(setFormValue({id: "Fields", value: []}));

                                                    formRenderProps.onChange("IsAggregate", { value: isAggregate});                                            
                                                    formRenderProps.onChange("AggregateExpressionId", { value: null});
                                                    formRenderProps.onChange("AggregateFunctionId", { value: 0});
                                                    formRenderProps.onChange("FieldId", { value: null});
                                                    formRenderProps.onChange("Fields", []);
                                                }} />
                                        </div>       
                                    </div>    
                                }     
                                {
                                    ((pageState.mode ==1 || pageState.mode == 2) && pageState.formValues.TypeId == 1) &&
                                    <div className="value-section">
                                        <div className="row1">
                                                <RadioButton
                                                    name="groupValuetype"
                                                    value={true}
                                                    checked={true === pageState.formValues.IsAggregate}
                                                    label={t("datasources.aggexp")}
                                                    disabled={pageState.isProcessing || pageState.formValues.IsSystem}
                                                    onChange={e =>
                                                    {
                                                        dispatch(setFormValue({id: "IsAggregate", value: e.value}));
                                                        dispatch(setFormValue({id: "AggregateExpressionId", value: null}));
                                                        dispatch(setFormValue({id: "AggregateFunctionId", value: 0}));
                                                        dispatch(setFormValue({id: "FieldId", value: null}));
                                                        dispatch(setFormValue({id: "Fields", value: []}));

                                                        formRenderProps.onChange("IsAggregate", { value: e.value});
                                                        formRenderProps.onChange("AggregateExpressionId", { value: null});
                                                        formRenderProps.onChange("AggregateFunctionId", { value: 0});
                                                        formRenderProps.onChange("FieldId", { value: null});
                                                        formRenderProps.onChange("Fields", []);
                                                    }}
                                                />
                                                <Field
                                                    id={"AggregateExpressionId"}
                                                    name={"AggregateExpressionId"}
                                                    component={FormDropDownListById} 
                                                    data={aggregateExpressions} dataItemKey="Id" textField="Title"  
                                                    onChange={ e => dispatch(setFormValue({id: "AggregateExpressionId", value:e.value}))}
                                                    disabled={pageState.processing || pageState.formValues.IsSystem || !pageState.formValues.IsAggregate}
                                                    style={{width: "100%", marginTop:5}}

                                                    />                                            
                                        </div>
                                        <div className="row2" style={{marginTop:30}}>
                                            <RadioButton
                                                    name="groupValuetype"
                                                    value={false}
                                                    checked={false === pageState.formValues.IsAggregate}
                                                    label={t("datasources.aggfct")}
                                                    disabled={pageState.isProcessing || pageState.formValues.IsSystem}
                                                    onChange={e =>
                                                    {
                                                        dispatch(setFormValue({id:"IsAggregate", value: e.value}));
                                                        dispatch(setFormValue({id: "AggregateExpressionId", value: null}));
                                                        dispatch(setFormValue({id: "AggregateFunctionId", value: 0}));
                                                        dispatch(setFormValue({id: "FieldId", value: null}));
                                                        dispatch(setFormValue({id: "Fields", value: []}));

                                                        formRenderProps.onChange("IsAggregate", { value: e.value});
                                                        formRenderProps.onChange("AggregateExpressionId", { value: null});
                                                        formRenderProps.onChange("AggregateFunctionId", { value: 0});
                                                        formRenderProps.onChange("FieldId", { value: null});
                                                        formRenderProps.onChange("Fields", []);
                                                    }}
                                                />
                                            <div style={{display: "flex", justifyContent:"space-between", marginTop:10}}>
                                                <div style={{width: 220}}>
                                                    <Field
                                                        id={"AggregateFunctionId"}
                                                        name={t("datasources.aggfctid")}
                                                        component={FormDropDownListById}
                                                        data={aggregateFunctions} dataItemKey="id" textField="title"  
                                                        onChange={ e =>
                                                            {
                                                             dispatch(setFormValue({id: "AggregateFunctionId", value:e.value}));

                                                             dispatch(setFormValue({id: "FieldId", value: null}));
                                                             formRenderProps.onChange("FieldId", { value: null});
                                                            }}
                                                        disabled={pageState.processing || pageState.formValues.IsSystem || pageState.formValues.IsAggregate}
                                                        style={{width: "100%"}}
                                                        />    
                                                </div>
                                                <div style={{flex:1,marginLeft: 16}}>
                                                    <Field
                                                        id={"FieldId"}
                                                        name={t("datasources.fieldId")}
                                                        component={FormDropDownListById}
                                                        data={fields} dataItemKey="Id" textField="Title"  
                                                        onChange={ e => dispatch(setFormValue({id: "FieldId", value:e.value}))}
                                                        disabled={pageState.processing || pageState.formValues.IsSystem || pageState.formValues.IsAggregate}
                                                        style={{width: "100%"}}
                                                        />  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }  

                                {
                                    <TableValueList 
                                        style={{marginTop: pageState.formValues.ViewMode == 1 ? 30 : 0}}
                                        formRenderProps={formRenderProps}
                                        onToggleViewMode={e => {
                                            let viewMode = !pageState.formValues.ViewMode;

                                            dispatch(setFormValue({id:"ViewMode", value: viewMode}));
                                        }}
                                        onFieldRemove={props.onFieldRemove} 
                                        onOpenFieldsDialog={props.onOpenFieldsDialog} onCloseFieldsDialog={props.onCloseFieldsDialog} onFieldCheck={props.onFieldCheck}
                                        onSaveFieldsDialog={props.onSaveFieldsDialog} onFieldDragStart={props.onFieldDragStart} onFieldDragOver={props.onFieldDragOver} onFieldDrop={props.onFieldDrop}
                                        onFieldsClear={props.onFieldsClear} onFieldTitleChange={props.onFieldTitleChange} onFieldGroupingChange={props.onFieldGroupingChange}
                                        onOpenComputedFieldDialog={props.onOpenComputedFieldDialog} onValidateComputedFieldDialog={props.onValidateComputedFieldDialog} onSaveComputedFieldDialog={props.onSaveComputedFieldDialog} onCloseComputedFieldDialog={props.onCloseComputedFieldDialog}
                                        onOpenExpressionFieldDialog={props.onOpenExpressionFieldDialog} onValidateExpressionFieldDialog={props.onValidateExpressionFieldDialog} onSaveExpressionFieldDialog={props.onSaveExpressionFieldDialog} onCloseExpressionFieldDialog={props.onCloseExpressionFieldDialog}
                                        onFieldSortDirectionChange={props.onFieldSortDirectionChange}
                                    />
                                }
                                { 
                                    !pageState.processing && !pageState.formValues.IsSystem && pageState.formValues.Fields.length > 0 &&
                                    <div style={{color: currentTheme.componentTextColor, fontSize: 13, fontStyle: "italic", marginTop:10, marginLeft: 4}}>{t("datasources.nb")}</div>
                                }
                                {
                                    formRenderProps.errors && formRenderProps.errors.Fields && 
                                    <div style={{padding: "0 4px 0 4px ", marginTop: 4, fontSize:13, fontStyle: "italic", color:currentTheme.error}}>
                                        {formRenderProps.errors.Fields}
                                    </div>  
                                }
                                         
                            </div>
                        </FormRegion>
                    </FormElement>                
            )}}
        />    
        <style>
            {
                `       
                    .datasources-page-form .k-form
                    {          
                        /*the kendo form which is child of my form.content*/              
                        width: 100%;
                        display: flex;
                        flex: 1;
                        justify-content: space-between;
                        padding: 0 24px 12px 24px;/*keep 12px in right and bottom so that when minimizing we keep a white region to the right and bottom; also keep 8px on the left*/
                    }                    

                    .datasources-page-form .form-region-1
                    {
                        width: 100%;
                        max-width: 1000px;
                        margin-top: 20px !important;/*to override kendo first child of k-form having marginTop=0*/                     
                    }

                    .datasources-page-form .form-region-1 .form-group-1
                    {
                        /*the first 2 <Field> have style.width=70%, the toggle container has also width 70% */
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }

                    .datasources-page-form .form-region-1  .form-group-1 .k-form-field:nth-child(1)
                    {
                        /*let title NOT go down by 26px as other fields*/
                        margin-top:0;
                    }

                    .datasources-page-form > .content
                    {
                        padding: 0px;
                        background-color: transparent;
                        align-items: flex-start;
                    }
                    
                    .datasources-page-form .form-region-root
                    {
                        background-color: transparent;
                    }

                    .datasources-page-form .form-group-1 > div > .k-form-field:first-child
                    {
                        flex: 1;
                    }

                    .datasources-page-form .form-group-1 .toggle-container
                    {
                        width: 100%;                    
                        justify-content: space-between;
                        border-color: ${currentTheme.componentBorderColor};
                        max-width: 1000px;
                        margin-top:8px;
                    }

                    .datasources-page-form .form-group-1 .list-container
                    {
                        /*when type is table data source, the list of fields to have at least 40px of height*/
                        min-height: 180px;
                    }

                    .datasources-page-form .k-form .value-section
                    {
                        width: 100%;
                        margin-top:32px;
                    }   

                    .datasources-page-form .k-form .value-section .row1 .k-form-field
                    {
                        margin-top: 3px;
                    }

                    .datasources-page-form input.k-input, .datasources-page-form textarea.k-textarea, 
                    .datasources-page-form .k-dropdownlist .k-input-inner
                    {
                        /*make input controls have a bit more height*/
                        padding: 6px 8px;
                        flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }

                    @media (max-width: 1024px)
                    {
                        .datasources-page-form .k-form
                        {
                            padding: 0 16px 16px;
                            overflow-x: hidden;
                        }

                        .datasources-page-form .form-region-1
                        {
                            margin-top: 12px !important;
                        }

                        .datasources-page-form .k-form .value-section
                        {
                            margin-top: 20px;
                        }

                        .datasources-page-form .k-form .value-section .row2 > div
                        {
                            flex-direction: column;
                            gap: 12px;
                        }

                        .datasources-page-form .k-form .value-section .row2 > div > div
                        {
                            width: 100% !important;
                            margin-left: 0 !important;
                            margin-right: 0 !important;
                        }
                    }
                `
            }
        </style>
    </Fragment>
  );
};
